import { defineMessages } from 'react-intl';

export default defineMessages({
  AboutTeslaHeader: {
    id: 'Grohmann.Footer.AboutTesla.Header',
    defaultMessage: 'About Tesla Automation',
  },
  AboutTeslaOne: {
    id: 'Grohmann.Footer.AboutTesla.One',
    defaultMessage:
      'Tesla Automation is a world-leader in highly automated methods of manufacturing.',
  },
  AboutTeslaTwo: {
    id: 'Grohmann.Footer.AboutTesla.Two',
    defaultMessage:
      'Established in 1983 as Grohmann Engineering, the company has been at the forefront of automation and innovation for over three decades.',
  },
  AboutTeslaThree: {
    id: 'Grohmann.Footer.AboutTesla.Three',
    defaultMessage:
      'The formation of Tesla Automation in 2016 enables exponential improvement of production speed and quality, while substantially reducing the capital expenditures required per vehicle.',
  },
  AboutTeslaFour: {
    id: 'Grohmann.Footer.AboutTesla.Four',
    defaultMessage:
      'Tesla Automation has its headquarters in Prüm, Germany with additional locations in Neutraubling and Neuwied.',
  },
  EqualOpportunityOne: {
    id: 'Grohmann.Footer.EqualOpportunity.Global',
    defaultMessage:
      'Tesla Automation is an equal opportunity employer. All aspects of employment including the decision to hire, promote, discipline, or discharge, will be based on merit, competence, performance, and business needs. We do not discriminate on the basis of race, color, religion, marital status, age, national origin, ancestry, physical or mental disability, medical condition, pregnancy, genetic information, gender, sexual orientation, gender identity or gender expression, veteran status, or any other status protected under federal, state, or local law.',
  },
});
